
import maIsohService from "../maIsohService/maIsohService";
import userServiceModule from "../userService/userService";

require('angular-base64/angular-base64.min');
import notifyModule from '../../services/notificationService/notificationService';
import Raven from 'raven-js';
import moment from 'moment';
import Dexie from 'dexie';
import ngSanitize from "angular-sanitize";

const db = new Dexie('autovraky');

// Declare tables, IDs and indexes
db.version(1).stores({
	cars: '++id,car'
});

//osobaPrijala,souhlasKraj,souhlasCJ,souhlasOd,souhlasDo,datumPrijeti,kodZeme,kategorie,model,barva,vin,cisloMotoru,cisloCasti,cisloTp,rokVyroby,rokRegCR,hmotnost,predalIco,predalDatumNarozeni,predalCisloDokladuTotoznosti,predalNazev,predalUlice,predalObec,predalPsc,predalZuj,predalZeme,bezCasti,datumPravniMoc,datumKontroly,datumStorna,uid,ident,zdarma,hmotnostDleTP,datumLikvidace,duvodNeuvedeniVin,fotoVINOdeslano,fotoInterierOdeslano,fotoExterierOdeslano,cisloDokladu,ic,zuj,provoz,registracniZnacka,znacka,znackaKod,status,datumPrijetiDate,fotoVIN,fotoInterier,fotoExterier

export default angular.module('carsService', [
	maIsohService,
	userServiceModule,
	notifyModule,
	'base64',
	ngSanitize
])
	.service('carsService', function(maIsoh, userService, notify, $log, $base64, $sanitize) {
		this.cars = null;
		this.carsLoaded = false;
		
		
		this.loadCarsFromStorage = () => {
			if (this.carsLoaded) {
				return new Promise((resolve) => resolve(true));
			}
			
			return new Promise((resolve) => {
				/**
				 * Set default storage and set values
				 */
				let localCars = localStorage.getItem('carsService');
				let oldCars;
				
				if(angular.isUndefined(localCars) || localCars == null || localCars == '' || localCars.length === 0) {
					oldCars = [];
				} else {
					oldCars = JSON.parse(localCars);
				}
				
				
				//we have old cars in localstorage, lets convert them to indexedDB and purge them
				if (oldCars.length > 0) {

					let hasError = false;
					oldCars.forEach((car) => {
						try {
							db.cars.put(car);
						} catch (e) {
							console.warn('Error when converting car', e);
							hasError = true;
							Raven.captureException(e, {extra: car});
						}
					});
					

					if (!hasError) {
						db.cars.count((count) => {
							Raven.captureMessage('Uspesna konverze - ' + count + ' aut');
							localStorage.setItem('carsService', []);
						});
					} else {
						Raven.captureMessage('Uspesna konverze - ' + count + ' aut')
					}
				}
				
				db.cars.toArray((loadedCars) => {
					this.cars = loadedCars;
					this.carsLoaded = true;
					resolve(true);
				});
			});
		};
		
		/**
		 * Get cars from local JSON file
		 * @param {Object|null} filter
		 * @returns {*|Array}
		 */
		this.getCars = (filter) => {
			if (!angular.isArray(this.cars)) {
				this.cars = [];
			}
			
			return this.cars;
		};
		
		/**
		 * Set the whole DB of cars, useful for backup restore
		 * @param cars
		 */
		this.setCars = (cars) => {
			this.cars = cars;
			this.persistCars();
		};
		
		/**
		 * Return number of cars with same PCP
		 * @param pcp
		 * @returns {Number}
		 */
		this.pcpExists = (pcp) => {
			return this.cars.filter((car) => car.cisloDokladu == pcp).length;
		};
		
		/**
		 * Load cars from MA ISOH
		 * @returns {*}
		 */
		this.loadCars = () => {
			let user = userService.getUserSettings();
			

			return maIsoh.loadCars(user.workplace.ic, user.workplace.zuj, user.workplace.provoz, user.workplace.ident).then((result) => {
				for(const car of result) {
					car.rokRegCR = car.rokRegistraceCr; // inconsistency in maisoh api
				}
				this.cars = result;
				
				//no cars in MA ISOH
				if (angular.isUndefined(this.cars)) {
					this.cars = [];
				}
				
				// for first car it returns only object, so convert it to array
				if (!angular.isArray(this.cars)) {
					this.cars = [this.cars];
				}
				
				let pcp = 0;
				this.cars.forEach((car, index) => {
					car.cisloDokladu = parseInt(car.cisloDokladu);
					this.cars[index].cisloDokladu = car.cisloDokladu;
					this.cars[index].kategorie = parseInt(car.kategorie);
					this.cars[index].rokVyroby = parseInt(car.rokVyroby);
					this.cars[index].rokRegCR = parseInt(car.rokRegCR);
					this.cars[index].predalIco = parseInt(car.predalIco);
					this.cars[index].predalPsc = parseInt(car.predalPsc);
					this.cars[index].hmotnost = parseFloat(car.hmotnost);
					this.cars[index].hmotnostDleTP = parseFloat(car.hmotnostDleTP);
					this.cars[index].datumPrijetiDate = moment(car.datumPrijeti, 'DD.MM.YYYY HH:mm:ss').toDate(); //from MA ISOH API - 11.12.2017 12:22:24
					
					if (car.cisloDokladu > pcp) {
						pcp = car.cisloDokladu;
					}
				});
				
				userService.setPcp(pcp);
				this.persistCars();
				
				return this.cars;
			}).catch((error) => {
				notify.error(error);
			});
		};
		
		this.loadCar = (car) => {
			let user = userService.getUserSettings();

			return maIsoh.loadCar(user.workplace.ic, user.workplace.zuj, user.workplace.provoz, car.cisloDokladu, car.registracniZnacka, car.vin, car.predalIco, car.predalDatumNarozeni, car.predalCisloDokladuTotoznosti).then((result) => {
				let car = result.json.autovrak;
				
				car.cisloDokladu = parseInt(car.cisloDokladu);
				car.kategorie = parseInt(car.kategorie);
				car.rokVyroby = parseInt(car.rokVyroby);
				car.rokRegistraceCr = parseInt(car.rokRegistraceCr);
				car.predalIco = parseInt(car.predalIco);
				car.predalPsc = parseInt(car.predalPsc);
				car.hmotnost = parseFloat(car.hmotnost);
				car.hmotnostDleTP = parseFloat(car.hmotnostDleTP);
				car.datumPrijetiDate = moment(car.datumPrijeti, 'DD.MM.YYYY HH:mm:ss').toDate(); //from MA ISOH
				
				this.updateCar(car);
				
				return car;
			}).catch((error) => {
				notify.error(error);
			});
		};
		
		/**
		 * Return cars by given invoice number
		 * @param number
		 * @returns {Array.<T>}
		 */
		this.getCarByInvoiceNumber = (number) => {
			return this.cars.filter((car) => car.cisloDokladu == number);
		};
		
		/**
		 * Adds car to DB
		 * @param car
		 */
		this.addCar = (car) => {
			car = this.sanitizeInputs(car);
			this.cars.unshift(car);
			// userService.incrementPcp();
			userService.setPcp(car.cisloDokladu);
			this.persistCars();
		};
		
		/**
		 * Updates given car in DB
		 * @param car
		 * @param oldCar
		 */
		this.updateCar = (car, oldCar) => {
			let pcp = car.cisloDokladu;
			
			if (angular.isDefined(oldCar) && oldCar.cisloDokladu !== car.cisloDokladu) {
				pcp = oldCar.cisloDokladu;
			}

			car = this.sanitizeInputs(car);

			this.cars.forEach((row, index) => {
				if (pcp === row.cisloDokladu) {
					this.cars[index] = car;
				}
			});
			
			this.persistCars();
		};

		this.sanitizeInputs = (car) => {
			car['registracniZnacka'] = $sanitize(car['registracniZnacka']);
			/**
			car['vin'] = $sanitize(car['vin']);
			car['cisloTp'] = $sanitize(car['cisloTp']);
			car['model'] = $sanitize(car['model']);
			car['barva'] = $sanitize(car['barva']);
			car['osobaPrijala'] = $sanitize(car['osobaPrijala']);
			car['predalCisloDokladuTotoznosti'] = $sanitize(car['predalCisloDokladuTotoznosti']);
			car['predalNazev'] = $sanitize(car['predalNazev']);
			car['predalObec'] = $sanitize(car['predalObec']);
			car['predalUlice'] = $sanitize(car['predalUlice']);
			car['poznamka'] = $sanitize(car['poznamka']);*/
			return car
		}

		/**
		 * Persist cars to DB
		 */
		this.persistCars = () => {
			db.cars.clear();
			this.cars.forEach((car) => {
				try {
					db.cars.put(car);
				} catch (e) {
					console.warn('Error when converting car', e);
					Raven.captureException(e, {extra: car});
				}
			});
		};
		
		this.purgeCars = () => {
			this.cars = [];
			this.persistCars();
		};
		
		/**
		 * Deletes a car or set it canceled (if its already in MA ISOH)
		 * @param car
		 */
		this.deleteCar = (car) => {
			return new Promise((resolve, reject) => {
				if (car.uid) {
					Raven.captureMessage('Stornuju auto', {extra: car});
					
					maIsoh.stornoCar(car.uid).then(() => {
						//this car is already in MA ISOH, lets just cancel it
						let now = new Date();
						car.datumStorna = now.getDate() + '.' + (now.getMonth() + 1) + '.' + now.getFullYear() + ' ' + now.getHours() + ':' + now.getMinutes() + ':' + now.getSeconds();
						
						this.cars.forEach((item) => {
							if (item.uid === car.uid) {
								item = car;
							}
						});
						
						this.persistCars();
						resolve('canceled');
					}).catch((e) => {
						// notify.error('Nepodařilo se stornovat autovrak, ' + e.message);
						Raven.captureMessage('Nepodarilo se stornovat vrak', {
							extra: {
								car: car,
								error: e
							}
						});
						
						reject('Nepodařilo se stornovat autovrak, ' + e.message);
					});
				} else {
					Raven.captureMessage('Mazu auto', {extra: car});
					this.cars = this.cars.filter((item) => item.cisloDokladu != car.cisloDokladu);
					this.persistCars();
					resolve('deleted');
				}
			});
		};
		
		/**
		 * Add photos to car
		 * @param car
		 * @param {Object} photos
		 */
		this.addPhotos = (car, photos) => {

			this.cars.forEach((row, index) => {
				if (car.cisloDokladu == row.cisloDokladu) {
					
					const savePhoto = (carIndex, photo, type) => {
						let reader = new window.FileReader();
						reader.readAsDataURL(photo);
						reader.onloadend = () => {
							this.cars[carIndex][type] = reader.result;
							this.cars[carIndex][type + 'Odeslano'] = ''; //reset sent time, so we will send it again
							this.persistCars();
						};
					};
					
					if (angular.isDefined(photos.vin)) {
						savePhoto(index, photos.vin, 'fotoVIN');
					}
					
					if (angular.isDefined(photos.inside)) {
						savePhoto(index, photos.inside, 'fotoInterier');
					}
					
					if (angular.isDefined(photos.outside)) {
						savePhoto(index, photos.outside, 'fotoExterier');
					}
					
				}
			});
			
			this.persistCars();
		};
		
		/**
		 * Converts base64 encoded string to Blob object
		 * @param b64Data
		 * @param contentType
		 * @param sliceSize
		 * @returns {Blob}
		 */
		this.b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
			const byteCharacters = atob(b64Data);
			const byteArrays = [];
			
			for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
				const slice = byteCharacters.slice(offset, offset + sliceSize);
				
				const byteNumbers = new Array(slice.length);
				for (let i = 0; i < slice.length; i++) {
					byteNumbers[i] = slice.charCodeAt(i);
				}
				
				const byteArray = new Uint8Array(byteNumbers);
				
				byteArrays.push(byteArray);
			}
			
			const blob = new Blob(byteArrays, {type: contentType});
			return blob;
		};
		
	}).name;



// WEBPACK FOOTER //
// build/services/carsService/carsService.js